import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Reset the scroll position on every route change.
//
// The browser only restores scroll for real history navigations; a pushState
// from a <Link> or navigate() keeps whatever offset the previous page had. So
// clicking a product card halfway down the homepage used to open the next page
// already scrolled halfway down.
//
// Pages used to handle this individually with their own window.scrollTo(0, 0)
// and most simply didn't — the product listing among them. Doing it once here
// covers every route, including ones added later.
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // POP is browser back/forward. There the expected behaviour is the
    // opposite: return the reader to where they were, so leave it alone.
    if (navigationType === "POP") return;
    window.scrollTo(0, 0);
    // `search` as well as `pathname`: several navigations change only the query
    // string — checkout advancing to ?step=3, and a category link that differs
    // only by ?view_all= — and those left the reader stranded mid-page.
  }, [pathname, search, navigationType]);

  return null;
}
